<template>
    <div>
        <div>
            <RulesManager class="" :group="getSelectedEvent" type="eventPriceGroups"/>
        </div>

        <!-- Title -->
        <div v-if="getEventRulesHistory.length > 0">
            <div class="border-bottom-medium pt-4"></div>

            <h3 class="my-4">History Rules</h3>
            
            <div class="col-sm-12 p-0" v-if="!getLoadingHistory">
                <table class="table narrow">
                    <thead>
                        <tr>
                            <th class="text-center fs-small" style="width: 15%;">ID</th>
                            <th class="fs-small" style="width: 25%;">Rule Name</th>
                            <th class="fs-small" style="width: 30%;">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="w-100 tr-size" v-for="rule in getEventRulesHistory">
                            <td class="text-center">
                                <span class="fs-small">{{rule.eventId}}</span>
                            </td>
                            <td>
                                <span class="fs-small">{{rule.priceRuleName}}</span>
                            </td>
                            <td>
                                <span class="fs-small">{{getStatus(rule.status)}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="getLoadingHistory" class="p-4 text-center">
                <div class="fs-large mb-2">Loading Rule History</div>
                <loader></loader>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import RulesManager from '../../../components/inventory/products/components/RulesManager'
import Loader from '@/tools/loaders/loader1'

export default {
    created() {
        if (this.hasDynamicPricingRevenuePlugin) {
            this.initHistory();
        }
    },
    beforeDestroy() {
		this.clearEventRuleHistory();
	},
    computed: {
        ...mapGetters([
            'getSelectedEvent',
            'getEventRulesHistory',
            'getLoadingHistory',
            'isCreatingSingleEvent',
            'getHasDynamicPricingRevenuePlugin',
        ])
    },
    methods: {
        ...mapActions([
            'downloadRuleHistoryByEvent',
            'clearEventRuleHistory'
        ]),
        hasDynamicPricingRevenuePlugin() {
            return this.getHasDynamicPricingRevenuePlugin;
        },
        initHistory() {
            if (!this.isCreatingSingleEvent) this.downloadRuleHistoryByEvent(this.getSelectedEvent.id);
        },
        getStatus(statusType) {
            const status = {
                1: 'Applied',
                2: 'Reverted',
                3: 'AppliedSkipped',
                4: 'RevertedSkipped',
            };

            return status[statusType];
        }
    },
    components:{
        RulesManager,
        Loader
    }
}
</script>

<style lang="scss" scoped>
    table {
        th {
            font-weight: 400;
        }

        tbody {
            tr:hover {
                border: none;
                transform: none;
            }

            tr.noHover:hover {
                border: none;
                background-color: white;
                transform: none;
            }
        } 
    }

    .tr-size {  
        height: 40px;
    }
</style>



// WEBPACK FOOTER //
// areaRules.vue?88fce0a8